<template lang="pug">
  div(class="content")
    div(v-if="!form_done" class="md-layout md-gutter md-alignment-center-center")
      div(class="custom-div md-layout-item md-size-40 md-medium-size-55 md-xsmall-size-100")
        form(@submit.prevent="" autocomplete="on")
          md-card
            md-card-header(data-background-color="green")
              h4(class="title") New Account Registration
              p(class="category") Please fill in your information.
            md-card-content
              div(class="md-layout")
                div(class="md-layout-item md-size-100")
                  md-field
                    md-icon person
                    label UT EID
                    md-input(v-model="eid" type="text" required autocomplete="username")
                div(class="md-layout-item md-size-100")
                  md-field
                    md-icon person
                    label First Name
                    md-input(v-model="firstname" type="text" required)
                div(class="md-layout-item md-size-100")
                  md-field
                    md-icon person
                    label Last Name
                    md-input(v-model="lastname" type="text" required)
                div(class="md-layout-item md-size-100")
                  md-field
                    md-icon calendar_today
                    label Graduation Year
                    md-input(v-model="gradyear" type="text" required)
                div(class="md-layout-item md-size-100")
                  md-field
                    md-icon school
                    label School
                    md-input(v-model="major" type="text" required)
                div(class="md-layout-item md-size-100")
                  md-field
                    md-icon mail
                    label Email
                    md-input(v-model="email" type="text" required)
                div(class="md-layout-item md-size-100")
                  md-field
                    md-icon lock
                    label Password
                    md-input(v-model="password1" type="password" required)
                div(class="md-layout-item md-size-100")
                  md-field
                    md-icon lock
                    label Retype Password
                    md-input(v-model="password2" type="password" required)
                div(class="text-center md-layout-item")
                  md-button(type="submit" v-on:click="signUp") Sign Up
    div(v-else class="md-layout md-gutter md-alignment-center-center")
      div(class="custom-div md-layout-item md-size-40 md-medium-size-55 md-xsmall-size-100")
        md-card
          md-card-header(data-background-color="green")
            h4(class="title") New Account Registration
          md-card-content
            div(class="md-layout" style="text-align: center;")
              h4 Thank you for registering! To activate your account, complete the email verification. <br><br>Sign in 
                router-link(to='signin') here.
</template>

<script>
import axios from 'axios';

export default {
    data() {
      return{
        eid: '',
        email: '',
        firstname: '',
        major: '',
        gradyear: '',
        lastname: '',
        password1: '',
        password2: '',
        error: false,
        form_error: false,
        form_done: false,
      };
    },
    methods: {
        signUp() {
          this.checkForm();
          if(!this.form_error){
            let load = {
              eid: this.eid.toLowerCase(),
              password: this.password1,
              email: this.email,
              first_name: this.firstname,
              last_name: this.lastname,
              major: this.major,
              grad_year: this.gradyear,
            };
            axios.post('/api/register', load)
            .then((response) => {
              this.form_done = true;
            }).catch(() => {
              this.error = true;
            });
          }
        },
        checkForm() {
          this.form_error = false;
          let all_present = this.eid && this.email && this.firstname && this.lastname && this.password1 && this.password2 && this.major && this.gradyear;
          let password_match = (this.password1 === this.password2);
          this.form_error = !(all_present && password_match);
        }

    }
}
</script>

<style scoped>
  .custom-div{
    margin-top: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/UserManagement/Register.vue